import React from 'react';
import { useSelector } from 'react-redux';
import { usePrefs, useRequestData } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { setNewRelicCustomAttribute } from 'ddc-new-relic';

import vehiclePropType from '../../../propTypes/vehiclePropType';
import { selectIsListLayout } from '../../../utilities/layout';
import VehicleAttributeItem from './VehicleAttributeItem';

const VehicleAttributeList = ({ vehicle }) => {
	const { layout } = useSelector((state) => state.layout);
	const isListLayout = useSelector((state) => selectIsListLayout(state));
	const {
		commentsEnableOnMobile,
		simplifiedLimitedAttributes,
		showInformationTabs
	} = usePrefs();
	const { deviceType } = useRequestData();

	const { attributes = [] } = vehicle;

	const displayDetailList = () => {
		return attributes.map((detail, idx) => {
			const {
				name: detailName,
				labeledValue: detailLabeledValue,
				normalizedValue = null
			} = detail;

			const swatchColor =
				normalizedValue && normalizedValue !== 'Other'
					? normalizedValue.toLowerCase()
					: null;
			if (
				detailName === 'comments' &&
				commentsEnableOnMobile !== 'true' &&
				deviceType === 'MOBILE'
			) {
				return null;
			}
			if (
				!isListLayout &&
				simplifiedLimitedAttributes &&
				idx >= +simplifiedLimitedAttributes
			) {
				return null;
			}
			if (!isListLayout && detailName === 'odometer') {
				return null;
			}
			// Show odometer when it is list layout and detailLabeledValue contains actual miles not like just "miles"
			if (
				isListLayout &&
				detailName === 'odometer' &&
				typeof detailLabeledValue === 'string' &&
				!/\d/.test(detailLabeledValue)
			) {
				return null;
			}
			if (detail.name === 'locationDistance') {
				setNewRelicCustomAttribute('location-distance-set', true);
			}
			return (
				<VehicleAttributeItem
					key={detailName}
					detailName={detailName}
					detailValue={detailLabeledValue}
					swatchColor={swatchColor}
				/>
			);
		});
	};
	return (
		<ul
			className={setClassNames([
				'vehicle-card-description',
				'list-unstyled',
				'w-100',
				deviceType === 'MOBILE' ? 'ddc-font-size-small' : null,
				deviceType !== 'MOBILE' && !isListLayout
					? 'ddc-font-size-xsmall'
					: null,
				layout === 'list' ||
				(!isListLayout &&
					+simplifiedLimitedAttributes &&
					showInformationTabs?.toLowerCase().includes('info'))
					? 'single-col'
					: null
			])}
		>
			{displayDetailList()}
		</ul>
	);
};

VehicleAttributeList.propTypes = {
	vehicle: vehiclePropType.isRequired
};

export default VehicleAttributeList;
